var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { memo } from 'react';
import { t } from '@lingui/core/macro';
import { useLingui } from '@lingui/react';
import { TableBodyCell, TableCellEmpty, TableCellText } from '@pocketlaw/tetris';
function AmountCellComponent(props) {
    const { amount, currency } = props, rest = __rest(props, ["amount", "currency"]);
    const { i18n } = useLingui();
    const { locale } = i18n;
    if (!amount) {
        return (<TableBodyCell {...rest}>
        <TableCellEmpty />
      </TableBodyCell>);
    }
    const formattedAmount = currency &&
        new Intl.NumberFormat(locale, {
            style: 'currency',
            currency,
            currencyDisplay: 'narrowSymbol',
            unitDisplay: 'short',
        }).format(amount);
    const secondaryText = currency || t({ message: 'No currency set', comment: 'Search results table: When no currency is set' });
    const primaryText = formattedAmount || `${amount}`;
    return (<TableBodyCell {...rest}>
      <TableCellText primary={primaryText} secondary={secondaryText}/>
    </TableBodyCell>);
}
export const AmountCell = memo(AmountCellComponent);
